<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="save" :loading="btnLoading">保存</el-button>
      <!-- <el-button  @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <el-form :model="doct" label-position="right" class="mainfrom from_input">
        <div class="row">
            <el-form-item label="单据分类"  prop="doctname" >
              <el-input v-model.trim="doct.doctname" :maxlength="40" show-word-limit :disabled="disable"></el-input>
            </el-form-item>

            <el-form-item label="生成方法" prop="doctscol">
              <el-select v-model="doct.doctmethodid" placeholder="请选择" :disabled="disable">
                <el-option v-for="(item, index)  in methodList" :key="item.methodid" :label="item.methodname" :value="item.methodid">
                </el-option>
              </el-select>
            </el-form-item>
        </div>
        <div class="row">
            <el-form-item label="单据表单" prop="doctrscol" >
              <el-select v-model="doct.doctmenuid" placeholder="请选择" :disabled="disable">
                <el-option v-for="(item, index)  in menuList"  :key="index" :label="item.menuname" :value="item.menuid">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="物流处理码" prop="doctlcscol">
              <el-select v-model="doct.doctlhcid" :clearable="true" :disabled="disable">
                <el-option v-for="(item, index) in lhcList" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
        </div>
        <div class="row">
            <el-form-item label="第二物流处理码" prop="doctrscol" >
              <el-select v-model="doct.doctsecondlhcid" placeholder="请选择" :disabled="disable">
                <el-option v-for="(item, index)  in lhcList"  :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

          <el-form-item label="第三物流处理码" prop="doctlcscol">
            <el-select v-model="doct.doctthirdlhcid" :clearable="true" :disabled="disable">
              <el-option v-for="(item, index) in lhcList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "doctform",
    data () {
      return {
        doct: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        menuList: [],
        methodList: [],
        lhcList: []
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getMenuList()
      this.getMethodList()
      this.getLhcList()
    },
    watch: {
    },
    filters: {
    },
    methods: {
      async init(){
          this.doct = this.$route.params.form
          this.type = Number(this.$route.params.type)
          this.disable = this.$route.params.type === 3 ? true : false
          this.btnLoading = false
          this.menuList = []
          this.methodList = []
          this.lhcList = []
      },
      async getMenuList () {
        this.menuList = await request({
          url: '/kfgl/menu/getMenuList',
          method: "get",
          params: {}
        })
      },
      async getMethodList () {
        this.methodList = await request({
          url: '/kfgl/method/getMethodList',
          method: "get",
          params: {}
        })
      },
      async getLhcList () {
        this.lhcList = await request({
          url: '/kfgl/lhc/getLhcList',
          method: "get",
          params: {}
        })
      },
      async save () {
        let model = {
          insertRecords: [],
          updateRecords: [],
          removeRecords: []
        }
        if (this.doct.doctid === 0) {
          model.insertRecords = [this.doct]
        } else {
          model.updateRecords = [this.doct]
        }
        await this.addOrEdit(model)
      },
      async addOrEdit (model) {
        if (model.insertRecords.length===0 && model.updateRecords.length === 0 && model.removeRecords.length ===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/kfgl/doct/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'doctIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 840px;
    }
  }
</style>
